<div style="overflow: hidden;">
<span
class="days-sufix"
[style.margin-left]="'calc((9.7px * (1 + ' + textLength + ')) + 15px)'"
>{{sufix}}</span>
<input [placeholder]="placeholder" (keydown)="onKeyDown($event)" (keyup)="onKeyDown($event)" type="{{inputType}}" autocomplete="off" [formControl]="controlForm">
</div>
